export default __webpack_public_path__ + "static/media/Sheri.33ce6e4f.jpg";